import { PageFooter } from '@facile-it/shark-morph/components'
import * as React from 'react'
import { footerPhrase } from '../../../../../shark-lib/ts/services/Legal/footerPhrase'

export const Footer: React.FC = () => {
    return (
        <PageFooter alignText="left" topBorder>
            {footerPhrase()}
        </PageFooter>
    )
}
